import { rem } from './rem';
import { ObjectOrArray } from 'styled-system';
import { StandardProperties } from 'csstype';

import { colors } from './colors';
import { FontWeight } from './typography';

export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Quarternary = 'quarternary',
  Flat = 'flat',
  Link = 'link',
}

export const buttons: ObjectOrArray<StandardProperties> = {
  [ButtonVariant.Primary]: {
    fontFamily: 'heading',
    background: colors.components.button.Primary.Background.Default,
    border: 'none',
    borderRadius: '80px',
    fontWeight: FontWeight.Normal,
    letterSpacing: '0.28px',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    lineHeight: 1.6,
    fontSize: rem(16),
    color: colors.components.button.Primary.Text.Default,
    transition: 'border-color .3s ease',
    '&:hover': {
      background: colors.components.button.Primary.Background.Hover,
      color: colors.components.button.Primary.Text.Hover,
    },
    '&[disabled]': {
      background: colors.components.button.Primary.Background.Disabled,
      color: colors.components.button.Primary.Text.Disabled,
    },
  },
  [ButtonVariant.Secondary]: {
    fontFamily: 'heading',
    background: colors.components.button.Secondary.Background.Default,
    border: 'none',
    borderRadius: rem(80),
    fontWeight: FontWeight.Medium,
    letterSpacing: '1.2px',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    lineHeight: 1.6,
    fontSize: rem(16),
    color: colors.components.button.Secondary.Text.Default,
    width: 'auto !important',
    transition: 'background-color .3s ease, color 0.3s ease',
    '&:hover': {
      backgroundColor: colors.components.button.Secondary.Background.Hover,
      color: colors.components.button.Secondary.Text.Hover,
    },
    '&[disabled]': {
      background: colors.components.button.Secondary.Background.Disabled,
      color: colors.components.button.Secondary.Text.Disabled,
    },
  },
  [ButtonVariant.Quarternary]: {
    fontFamily: 'heading',
    background: colors.components.button.Quarternary.Background.Default,
    border: 'none',
    borderRadius: '80px',
    fontWeight: FontWeight.Normal,
    letterSpacing: 0,
    paddingTop: rem(14),
    paddingBottom: rem(14),
    lineHeight: rem(16),
    fontSize: rem(16),
    color: colors.components.button.Quarternary.Text.Default,
    transition: 'border-color .3s ease',
    '&:hover': {
      background: colors.components.button.Quarternary.Background.Hover,
      color: colors.components.button.Quarternary.Text.Hover,
    },
    '&[disabled]': {
      background: colors.components.button.Quarternary.Background.Disabled,
      color: colors.components.button.Quarternary.Text.Disabled,
    },
  },
  [ButtonVariant.Flat]: {
    fontFamily: 'heading',
    color: colors.components.button.Ghost.Text.Default,
    background: 'transparent',
    border: 'none',
    borderRadius: rem(80),
    fontWeight: FontWeight.Medium,
    textDecoration: 'none',
    fontSize: rem(16),
    lineHeight: 1.6,
    marginTop: '6px',
    '&:hover': {
      color: colors.components.button.Ghost.Text.Hover,
      textDecoration: 'underline',
    },
    '&[disabled]': {
      color: colors.components.button.Ghost.Text.Disabled,
    },
  },
  [ButtonVariant.Link]: {
    fontFamily: 'heading',
    color: colors.base.Text.Link,
    background: 'transparent',
    border: 'none',
    textDecoration: 'underline',
    textTransform: 'none',
    fontWeight: FontWeight.Medium,
    transition: 'color 0.3s ease',
    fontSize: rem(16),
    lineHeight: 1,
    '&:hover': {
      color: colors.base.Text.SecondaryStatic,
    },
  },
};

export default buttons;
